<script setup lang="ts">
import { AssetType } from '~/apiClient';

// COMPOSABLE
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const { brandName, brandShortDescription, brandLongDescription } = useSlpParams(sellingMethod);

// DATA
const MIN_ACCORDION_CONTENT_LENGTH = 200;
</script>

<template>
    <div v-if="!!brandName && !!brandShortDescription" class="flex flex-col gap-8 py-8">
        <div class="border-t border-neutral-300" />

        <div class="flex flex-col gap-3">
            <h2 class="text-highlighted text-xl leading-7 font-semibold">{{ tt(`asset.type.${AssetType.Bus}`) }} {{ brandName }}</h2>

            <p class="text-sm leading-5">{{ brandShortDescription }}</p>
        </div>

        <template v-if="!!brandLongDescription">
            <UCollapsible v-if="brandLongDescription.length > MIN_ACCORDION_CONTENT_LENGTH" class="flex w-full flex-col gap-2 text-sm">
                <template #default="{ open }">
                    <UButton
                        color="neutral"
                        variant="link"
                        :ui="{
                            trailingIcon: 'group-data-[state=open]:rotate-180 transition-transform duration-200',
                        }"
                        class="group pl-0 font-medium no-underline"
                        trailing-icon="lucide:chevron-down"
                    >
                        {{ open ? tt('common.showLess') : tt('common.showMore') }}
                    </UButton>
                </template>

                <template #content>
                    {{ brandLongDescription }}
                </template>
            </UCollapsible>
            <p v-else class="text-sm leading-5">{{ brandLongDescription }}</p>
        </template>
    </div>
</template>
